<template>
  <div class="wrapper">
    <div class="section section-contacts">
      <div class="container">
        <div class="md-layout">
          <div class="
    					md-layout-item md-size-66 md-xsmall-size-100
    					mx-auto
            ">
            <h2 class="text-center">Kontakt</h2>
            <h4 class="text-center description">
              Schreiben Sie mir eine Nachricht mit Ihrem Anliegen.
            </h4>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select :items="genderChoices" v-model="gender" :error-messages="selectErrors" label="Anrede"
                        required @change="$v.gender.$touch()" @blur="$v.gender.$touch()"></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="first_name" :error-messages="first_nameErrors" label="Vorname" required
                        @input="$v.first_name.$touch()" @blur="$v.first_name.$touch()"></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field v-model="last_name" :error-messages="last_nameErrors" label="Nachname" required
                        @input="$v.last_name.$touch()" @blur="$v.last_name.$touch()"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="email" :rules="emailRules" :error-messages="emailErrors" label="Email"
                        required @input="$v.email.$touch()" @blur="$v.email.$touch()"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <vue-tel-input-vuetify defaultCountry="de" :preferred-countries="['de', 'fr']"
                        :only-countries="['de', 'fr', 'ch', 'at']" v-model="phone" :error-messages="phoneErrors"
                        :valid-characters-only="true" label="Telefon" placeholder="" required @input="$v.phone.$touch()"
                        @blur="$v.phone.$touch()">
                      </vue-tel-input-vuetify>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-textarea v-model="message" :error-messages="messageErrors" label="Ihre Nachricht" required
                        @input="$v.message.$touch()" @blur="$v.message.$touch()"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model.number="age" :error-messages="messageErrors" label="Ihr Alter" type="number"
                        required @input="$v.age.$touch()" @blur="$v.age.$touch()"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-radio-group v-model="prior_therapy" :error-messages="messageErrors"
                        label="Hatten Sie bereits Therapiesitzungen?" @change="$v.prior_therapy.$touch()">
                        <v-radio label="Ja" :value="'yes'"></v-radio>
                        <v-radio label="Nein" :value="'no'"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>


                  <h5>Angaben zur Krankenversicherung</h5>
                  <v-radio-group v-model="insurance" mandatory>
                    <v-radio label="Selbstzahler" value="self-payer"></v-radio>
                    <v-radio label="Private Krankenkasse" value="private"></v-radio>
                    <v-radio label="Gesetzliche Krankenkasse" value="statutory"></v-radio>
                  </v-radio-group>
                  <p class="checkbox-align">
                    Beim Absenden des Formulars stimmen Sie der Speicherung
                    Ihrer Daten zu. Informationen hierzu finden Sie im Impressum
                    unter
                    <a href="/impressum#datenschutz" target="_blank">Datenschutzerklärung.</a>
                  </p>
                  <v-checkbox v-model="confirmed_tos" :error-messages="checkboxErrors"
                    label="Ich habe die Datenschutzbestimmungen gelesen und bin mit der Speicherung meiner Daten einverstanden"
                    required @change="$v.confirmed_tos.$touch()" @blur="$v.confirmed_tos.$touch()"></v-checkbox>
                  <v-btn class="
    												md-rose
    												md-button
    												md-primary
    												md-round
    												md-theme-default
    											" @click="send_message">
                    <div v-if="!progress">Senden</div>
                    <div v-else>
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                  </v-btn>
                </v-container>
              </v-form>
            </template>
            <template>
              <div class="text-center">
                <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" color="blue" outlined>
                  {{ response }}
                  <template v-slot:action="{ attrs }">
                    <v-btn v-bind="attrs" @click="snackbar = false">
                      OK
                    </v-btn>
                  </template>
                </v-snackbar>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTelInputVuetify from "vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength, email, integer, minValue } from "vuelidate/lib/validators";
import Cookies from "js-cookie";

export default {
  name: "contact",
  components: {
    VueTelInputVuetify,
  },
  bodyClass: "landing-page",
  mixins: [validationMixin],
  data() {
    return {
      gender: null,
      genderChoices: ["Frau", "Herr", "Divers"],
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      message: null,
      age: null,
      prior_therapy: "no",
      insurance: null,
      confirmed_tos: null,
      nameRules: [(v) => !!v || "Ihr Name ist erforderlich"],
      emailRules: [
        (v) => !!v || "Ihre Email Adresse ist erforderlich.",
        (v) => /.+@.+/.test(v) || "Geben Sie eine gültige Email Adresse an.",
      ],
      response: null,
      progress: false,
      snackbar: false,
      snackbarTimeout: -1,
    };
  },
  validations: {
    gender: { required },
    first_name: { required, maxLength: maxLength(60) },
    last_name: { required, maxLength: maxLength(60) },
    phone: { required },
    email: { required, email },
    message: { required },
    age: { required, integer, minValue: minValue(0) },
    prior_therapy: { required },
    confirmed_tos: {
      checked(val) {
        return val;
      },
    },
  },
  computed: {
    checkboxErrors() {
      const errors = [];
      if (!this.$v.confirmed_tos.$dirty) return errors;
      !this.$v.confirmed_tos.checked &&
        errors.push("Sie müssen zustimmen, um die Anfrage zu senden");
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required &&
        errors.push("Dies ist eine erforderliche Angabe");
      return errors;
    },
    first_nameErrors() {
      const errors = [];
      if (!this.$v.first_name.$dirty) return errors;
      !this.$v.first_name.maxLength && errors.push("60 Zeichen maximal");
      !this.$v.first_name.required &&
        errors.push("Dies ist eine erforderliche Angabe");
      return errors;
    },
    last_nameErrors() {
      const errors = [];
      if (!this.$v.last_name.$dirty) return errors;
      !this.$v.last_name.maxLength && errors.push("60 Zeichen maximal");
      !this.$v.last_name.required &&
        errors.push("Dies ist eine erforderliche Angabe");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.phone.required &&
        errors.push("Dies ist eine erforderliche Angabe");
      return errors;
    },
    messageErrors() {
      const errors = [];
      if (!this.$v.message.$dirty) return errors;
      !this.$v.message.required &&
        errors.push("Schreiben Sie mir eine Nachricht mit Ihrem Anliegen.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push("Geben Sie eine gültige Email Adresse an.");
      !this.$v.email.required && errors.push("Ihre Email ist erforderlich");
      return errors;
    },
    ageErrors() {
      const errors = [];
      if (!this.$v.age.$dirty) return errors;
      !this.$v.age.required && errors.push("Ihr Alter ist erforderlich.");
      !this.$v.age.integer && errors.push("Alter muss eine Zahl sein.");
      return errors;
    },
    prior_therapyErrors() {
      const errors = [];
      if (!this.$v.prior_therapy.$dirty) return errors;
      !this.$v.prior_therapy.required &&
        errors.push("Bitte angeben, ob Sie bereits Therapie hatten.");
      return errors;
    },
  },

  methods: {
    send_message: function () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.progress = true;
        // this.$v.$touch();
        const API_BASE_URL =
          window.location.protocol +
          "//" +
          window.location.hostname +
          (process.env.VUE_APP_API_PORT
            ? `:${process.env.VUE_APP_API_PORT}`
            : "");
        const REST_API_CONTACT = API_BASE_URL + "/api/contact/";
        fetch(`${REST_API_CONTACT}`, {
          method: "POST",
          body: JSON.stringify({
            gender: this.gender,
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            phone: this.phone,
            message: this.message,
            age: this.age,
            prior_therapy: this.prior_therapy,
            insurance: this.insurance,
            confirmed_tos: this.confirmed_tos,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "X-CSRFToken": Cookies.get("csrftoken"),
          },
        })
          .then((response) => {
            if (response.status === 201 || response.status === 200) {
              this.snackbar = true;
              this.progress = false;
              this.response =
                "Ihre Anfrage wird bearbeitet. Sie erhalten in Kürze von mir Antwort.";
              return response.json();
            }
            if (response.status === 400 || response.status === 401) {
              this.snackbar = true;
              this.progress = false;
              this.response =
                "Haben Sie alle benötigten Informationen korrekt eingetragen?";
              return response.json();
            }
            if (response.status === 429) {
              this.snackbar = true;
              this.progress = false;
              this.response =
                "Ihre Anfrage wurde bereits abgesendet - Ich melde mich bei Ihnen sobald wie möglich.";
              return response.json();
            } else {
              this.snackbar = true;
              this.progress = false;
              this.response =
                "Die Anfrage konnte nicht weitergeleitet werden, ein interner Fehler liegt vor. Bitte wenden Sie sich direkt an praxis@amreischaal.com";
              return response.json();
            }
          })
          .then((json) => {
            if (!Object.keys(json).includes("errors")) {
            } else if (json.errors[0] === "Invalid token.") {
            } else {
            }
          })
          .catch(() => {
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.text-center {
  color: #3c4858;
}

.md-has-textarea+.md-layout {
  margin-top: 15px;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.checkbox-align {
  padding-left: 25px;
  font-size: 16px;
}

.font-16 {
  font-size: 16px;
}
</style>
